import React from 'react';
import Component from '@vfuk/core-card-interaction-slot';
const CardInteractionSlot = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardInteractionSlot;
